import { api } from '../../lib/api'
import ChatPanel from './ChatPanel'

export default function ProfileChat({ profileId, onProfileUpdated }: { profileId: string; onProfileUpdated?: () => void }) {
  return (
    <ChatPanel
      onAsk={async (text) => {
        const res = await api.profiles.chat(profileId, text)
        return res.data.reply
      }}
      onAddInfo={async (text) => {
        await api.profiles.update(profileId, text)
        onProfileUpdated?.()
      }}
      onNote={async (text) => {
        await api.profiles.updateFrontmatter(profileId, { notes: text })
      }}
      placeholders={{
        ask: 'Ask anything about this candidate...',
        addInfo: 'Add new information to merge into the profile...',
        note: 'Leave a private note (visible only in frontmatter)...',
      }}
      emptyHints={{
        ask: 'Ask anything about this candidate.',
        addInfo: 'Paste or type new information to merge into the profile.',
        note: 'Leave a private note. It will be stored in the profile frontmatter.',
      }}
    />
  )
}
